import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingStateProps {
  message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ message }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 240,
      py: 4,
    }}
  >
    <CircularProgress sx={{ mb: 2 }} />
    {message && <Typography variant="body2" color="text.secondary">{message}</Typography>}
  </Box>
);

export default LoadingState; 